import { FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction } from "../../../../utils";
import { isEqualJson } from "../../../../utils/equal/equal";
import { UserDataAction, fetchUserData, fetchUserDataActionTypes, UserDataResponse } from "../userDataActions";
import { saveItemActionTypes, SavedItemsUpdate, removeItemFromSavedActionTypes } from "./savedItemsActions";

export interface SavedItemsState {
    isFetching: boolean
    isUpdating: boolean
    data: string[]
    fetchError?: FetchErrorInfo
    updateError?: FetchErrorInfo
}

export const initialSavedItemsState: SavedItemsState = {
    data: [],
    isFetching: false,
    isUpdating: false
}

export const savedItemsReducer = (state: SavedItemsState = initialSavedItemsState, action: UserDataAction): SavedItemsState => {
    switch (action.type) {
        case fetchUserDataActionTypes.start: {
            return {
                ...state,
                isFetching: true
            }
        }
        case fetchUserDataActionTypes.success: {
            const successAction = action as SuccessFetchingAction<UserDataResponse>
            const newState: SavedItemsState = {
                ...state,
                isFetching: false,
            }
            if(!isEqualJson(successAction.result.savedItems, state.data)){
                newState.data = successAction.result.savedItems
            }
            return {
                ...newState
            }
        }
        case fetchUserDataActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                ...state,
                isFetching: false,
                fetchError: errorAction.error
            }
        }
        case removeItemFromSavedActionTypes.start:
        case saveItemActionTypes.start: {
            return {
                ...state,
                isUpdating: true
            }
        }
        case removeItemFromSavedActionTypes.success:
        case saveItemActionTypes.success: {
            const changeAction = action as SuccessFetchingAction<SavedItemsUpdate>
            return {
                ...state,
                isUpdating: false,
                data: changeAction.result
            }
        }
        case removeItemFromSavedActionTypes.error:
        case saveItemActionTypes.error: {
            const errorAction = action as ErrorFetchingAction
            return {
                ...state,
                isUpdating: false,
                updateError: errorAction.error
            }
        }
        default:
            return state
    }
}